// import React from "react";
// import { Card } from "primereact/card";
// import { Button } from "primereact/button";

// interface TaxSummaryProps {
//   taxPayerId: string;
//   submitUserForm: () => void;
//   submitLoading: boolean;
//   updatePreviousformState: any;
// }

// const TaxSummary: React.FC<TaxSummaryProps> = ({ taxPayerId, submitUserForm, submitLoading, updatePreviousformState }) => {
//   return (
//     <div className="tax-filing-information">
//       <div className="booking-container">
//         <Card
//           className="booking-card"
//           footer={
//             <div className="flex justify-content-end mr-4 mb-4" style={{ fontSize: "18px" }}>
//               <Button
//                 label="Go To Previous"
//                 icon="pi pi-arrow-left"
//                 iconPos="left"
//                 className="p-button-outlined mr-3"
//                 onClick={updatePreviousformState}
//               />

//               <Button
//                 label="Proceed To Payment"
//                 icon="pi pi-arrow-right"
//                 iconPos="right"
//                 className="common-primary-button"
//                 loading={submitLoading}
//                 onClick={submitUserForm}
//               />
//             </div>
//           }
//         >
//           <div className="booking-header">
//             <h1>Payment Instructions</h1>
//           </div>

//           <div className="tax-payer-summary">
//             {/* <div className="summary-header">
//               <h2>Important Payment Instructions</h2>
//             </div> */}

//             <div className="summary-content">
//               <div className="info-box">
//                 <div className="info-section text-center">
//                   <p>
//                     <strong>Kindly pay $30</strong> (our basic tax charges) prior to tax filing.
//                   </p>
//                   <p>Balance payment will be paid by client while signing document.</p>
//                   {/* <p>
//                     <strong>Interac ID:</strong>{" "}
//                     <a
//                       style={{
//                         color: "blue",
//                         textDecoration: "underline",
//                       }}
//                       href="mailto:as.nagra@gmail.com"
//                     >
//                       as.nagra@gmail.com
//                     </a>
//                   </p> */}
//                 </div>

//                 <div className="grid p-fluid formgrid">
//                   <div className="col-12 md:col-6">
//                     <div className="info-section">
//                       <h4>Optional Services</h4>
//                       <ul>
//                         <>
//                           Residents of BC or Manitoba, you may be eligible for rent benefits. There is an additional $10 service fee to apply. If you
//                           are married, only one spouse can claim the rent benefit. Please confirm your eligibility before making the payment.
//                         </>
//                       </ul>
//                     </div>
//                   </div>
//                   <div className="col-12 md:col-6">
//                     <div className="info-section">
//                       <h4>Additional Charges (If Applicable)</h4>
//                       <ul>
//                         <li>
//                           Work From Home: <strong>$75 – $100</strong>
//                         </li>
//                         <li>
//                           Self Employment: <strong>$60 – $150</strong>
//                         </li>
//                         <li>
//                           Long Haul Truck Driver: <strong>$100</strong>
//                         </li>
//                         <li>
//                           Moving expenses: <strong>$20</strong>
//                         </li>{" "}
//                         <li>
//                           Rental income: <strong>$100 per property</strong>
//                         </li>
//                         <li>
//                           Other services (if required): <strong>Ask for changes</strong>
//                         </li>
//                       </ul>
//                     </div>
//                   </div>
//                 </div>
//                 <hr />
//                 <div className="info-section">
//                   <h4>Important Notes</h4>
//                   <ul>
//                     <li>
//                       We work on <strong>first-come, first-serve</strong> basis.
//                     </li>
//                     <li>
//                       <strong>Charges are non-refundable.</strong>
//                     </li>
//                     <li>It is your responsibility to ensure all tax forms are sent. We will file taxes based on the documents provided.</li>
//                     <li>Please confirm charges for your tax filing beforehand.</li>
//                   </ul>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </Card>
//       </div>
//     </div>
//   );
// };

// export default TaxSummary;

import React, { useState } from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';

interface TaxSummaryProps {
  taxPayerId: string;
  submitUserForm: (type: any) => void;
  submitLoading: boolean;
  downloadLoading: boolean;
  updatePreviousformState: any;
  userData: any;
  errors: any;
  onInputChange: (e: any, name: string) => void;
}

const TaxSummary: React.FC<TaxSummaryProps> = ({
  userData,
  errors,
  onInputChange,
  taxPayerId,
  submitUserForm,
  downloadLoading,
  submitLoading,
  updatePreviousformState,
}) => {
  return (
    <>
      <div
        className="payment-instructions-wrapper"
        style={{ overflow: 'auto', height: 'auto' }}
      >
        <div className="payment-car ">
          {/* Header Section */}
          <div className="payment-header">
            <h1 className="payment-title">Payment Instructions</h1>
          </div>

          {/* Main Payment Info */}
          <div className="payment-intro">
            <p className="primary-instruction">
              Kindly pay <strong>$30</strong> (our basic tax charges) prior to
              tax filing.
            </p>
            <p className="secondary-instruction">
              Balance payment will be paid by client while signing document.
            </p>
          </div>

          {/* Two Column Layout */}
          <div className="payment-content-grid">
            {/* Left Column - Optional Services */}
            <div className="content-card optional-services-card">
              <div className="card-inner">
                <h3 className="section-heading">Optional Services</h3>
                <p className="service-description">
                  Residents of BC or Manitoba, you may be eligible for rent
                  benefits. There is an additional $10 service fee to apply. If
                  you are married, only one spouse can claim the rent benefit.
                  Please confirm your eligibility before making the payment.
                </p>
              </div>
            </div>

            {/* Right Column - Additional Charges */}
            <div className="content-card additional-charges-card">
              <div className="card-inner" style={{ overflow: 'hidden' }}>
                <h3 className="section-heading mb-0">
                  Additional Charges (If Applicable)
                </h3>
                <ul className="charges-list">
                  <li className="charge-item">
                    <span className="service-name">Work From Home:</span>
                    <span className="service-price">$75 – $100</span>
                  </li>
                  <li className="charge-item">
                    <span className="service-name">Self Employment:</span>
                    <span className="service-price">$60 – $150</span>
                  </li>
                  <li className="charge-item">
                    <span className="service-name">
                      Long Haul Truck Driver:
                    </span>
                    <span className="service-price">$100</span>
                  </li>
                  <li className="charge-item">
                    <span className="service-name">Moving expenses:</span>
                    <span className="service-price">$20</span>
                  </li>
                  <li className="charge-item">
                    <span className="service-name">Rental income:</span>
                    <span className="service-price">$100 per property</span>
                  </li>
                  <li className="charge-item">
                    <span className="service-name">
                      Other services (if required):
                    </span>
                    <span className="service-price">Ask for changes</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Important Notes Section */}
          <div className="important-notes-section">
            <div className="notes-card">
              <h3 className="notes-heading">Important Notes:</h3>

              <ul className="notes-list">
                <li className="note-item mb-1" style={{ fontSize: '1rem' }}>
                  We work on <strong>first-come, first-serve</strong> basis.
                </li>
                <li className="note-item mb-1" style={{ fontSize: '1rem' }}>
                  <strong>Charges are non-refundable.</strong>
                </li>
                <li className="note-item mb-1" style={{ fontSize: '1rem' }}>
                  It is client's responsibility to ensure all tax forms are
                  sent. We will file taxes based on the documents provided.
                </li>
                <li className="note-item mb-1" style={{ fontSize: '1rem' }}>
                  Please confirm total charges for your tax filing beforehand.
                </li>
              </ul>
              {/* <Checkbox inputId="ingredient1" name="pizza" value="Cheese" onChange={onIngredientsChange} checked={ingredients.includes("Cheese")} /> */}
              <div
                className="mt-5 mb-3 field-checkbox "
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  fontSize: '16px',
                }}
              >
                <Checkbox
                  inputId="checkOption3"
                  name="vacation_hold"
                  checked={userData.has_agreed === true}
                  onChange={(e) => onInputChange(e, 'has_agreed')}
                  className={errors['has_agreed'] && 'p-invalid'}
                />
                <label htmlFor="name">
                  I agreed to payment instruction{' '}
                  <span className="required" style={{ color: 'red' }}>
                    *
                  </span>
                </label>
                <small className="p-invalid-txt">{errors['has_agreed']}</small>
              </div>
            </div>
          </div>

          {/* Footer Buttons */}
          <div className="payment-footer" style={{ height: 'fit-content' }}>
            <Button
              label="Download PDF"
              icon="pi pi-file"
              iconPos="left"
              loading={downloadLoading}
              className="btn-secondary"
              onClick={() => submitUserForm('pdf')}
            />
            <div>
            <Button
              label="Go To Previous"
              icon="pi pi-arrow-left"
              iconPos="left"
              className="btn-secondary mr-2"
              onClick={updatePreviousformState}
            />
            <Button
              label="Proceed To Payment"
              icon="pi pi-arrow-right"
              iconPos="right"
              className="btn-primary"
              loading={submitLoading}
              onClick={() => submitUserForm('payment')}
              disabled={
                userData?.has_agreed === false || userData?.has_agreed == null
              }
            />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TaxSummary;
